/* DE CADEAUMETER — één logica, drie plekken.

   Meet wat er in de winkelwagen ligt dat meetelt voor de cadeaus en vertaalt
   dat naar één zin en één balkje met twee mijlpalen (sokken bij drempel 1,
   boxershorts bij drempel 2). Dezelfde functie voedt de productpagina, het
   sticky balkje en de winkelwagenlade, zodat er nergens twee verschillende
   bedragen kunnen staan.

   WAT MEETELT — dezelfde meetlat als assets/lodyfair-cart.js en de kassa:
   original_line_price (vóór regelkorting), zonder cadeauvarianten, zonder
   Verzekerde verzending, zonder producten met de tag cadeau, zonder regels
   met prijs 0. Tags staan niet in /cart.js; die komen uit /products/<handle>.js
   en worden per handle in sessionStorage bewaard.

   WANNEER HIJ BIJWERKT
   - het bestaande event cart:updated (theme.js) en ajaxProduct:added
   - elke fetch naar /cart/add|change|update|clear (fetch één keer omwikkeld)
   - pageshow (terug via de bladwijzer-cache)
   - variant:change (alleen de productpagina rekent dan opnieuw)

   Zonder JavaScript blijft elk blok leeg; de hoogte is in Liquid gereserveerd. */
(function () {
  'use strict';
  if (window.LfCadeaumeter) { return; }

  var mounts = [];
  var cfg = null;
  var cart = null;
  var meet = 0;
  var bezig = null;

  /* ---------- opslag (sessie) ---------- */
  function lees(sleutel, terugval) {
    try { var w = window.sessionStorage.getItem(sleutel); return w == null ? terugval : JSON.parse(w); }
    catch (e) { return terugval; }
  }
  function schrijf(sleutel, waarde) {
    try { window.sessionStorage.setItem(sleutel, JSON.stringify(waarde)); } catch (e) { /* privémodus */ }
  }

  /* ---------- hulpjes ---------- */
  function geld(centen) {
    var n = Math.max(0, Math.round(centen));
    var euro = Math.floor(n / 100), cent = n % 100;
    return '€' + String(euro).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (cent < 10 ? '0' : '') + cent;
  }
  function vul(sjabloon, sleutel, waarde) { return String(sjabloon).split('%' + sleutel + '%').join(waarde); }
  function veilig(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function leesLijst(s) {
    return String(s || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (n) { return n > 0; });
  }

  function leesCfg(el) {
    var d = el.dataset;
    return {
      d1: parseInt(d.d1, 10) || 8000,
      d2: parseInt(d.d2, 10) || 15000,
      tier2: d.tier2 !== 'false',
      cadeauVarianten: leesLijst(d.cadeauVarianten),
      verzekerd: parseInt(d.verzekerd, 10) || 0,
      goud: d.goud || '#C9A227',
      t: { a: d.tA, b: d.tB, c: d.tC, pla: d.tPla, plm: d.tPlm, pm: d.tPm, m1: d.tM1, m2: d.tM2, sluit: d.tSluit }
    };
  }

  /* ---------- status en zin ---------- */
  function status(bedrag) {
    if (cfg.tier2 && bedrag >= cfg.d2) { return 'C'; }
    if (bedrag >= cfg.d1) { return cfg.tier2 ? 'B' : 'C'; }
    return 'A';
  }
  function statusZin(bedrag) {
    var s = status(bedrag);
    if (s === 'A') { return vul(cfg.t.a, 'bedrag', geld(cfg.d1 - bedrag)); }
    if (s === 'B') { return vul(cfg.t.b, 'bedrag', geld(cfg.d2 - bedrag)); }
    return cfg.t.c;
  }
  function rang(s) { return s === 'C' ? 2 : s === 'B' ? 1 : 0; }

  /* ---------- meten ---------- */
  var tagsCache = lees('lfCmTags', {});
  var tagsOnderweg = {};

  function haalTags(handle) {
    if (tagsCache[handle]) { return Promise.resolve(tagsCache[handle]); }
    if (tagsOnderweg[handle]) { return tagsOnderweg[handle]; }
    tagsOnderweg[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = (p && p.tags) || [];
        tagsCache[handle] = tags; schrijf('lfCmTags', tagsCache);
        return tags;
      })
      .catch(function () { return []; })
      .then(function (tags) { delete tagsOnderweg[handle]; return tags; });
    return tagsOnderweg[handle];
  }

  function teltMee(item) {
    if (!item || !(item.original_price > 0)) { return Promise.resolve(false); }
    if (item.variant_id === cfg.verzekerd) { return Promise.resolve(false); }
    if (cfg.cadeauVarianten.indexOf(item.variant_id) !== -1) { return Promise.resolve(false); }
    return haalTags(item.handle).then(function (tags) { return tags.indexOf('cadeau') === -1; });
  }

  function meten(c) {
    var items = (c && c.items) || [];
    return Promise.all(items.map(teltMee)).then(function (wel) {
      return items.reduce(function (som, item, i) { return wel[i] ? som + item.original_line_price : som; }, 0);
    });
  }

  /* ---------- tekenen ---------- */
  var ICO_SOK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3h8v9l3.2 3.2a3.5 3.5 0 0 1-4.9 4.9L8 14V3z"/><path d="M8 7h8"/></svg>';
  var ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h16l1 12h-7l-2-5-2 5H3z"/><path d="M4 9h16"/></svg>';
  var ICO_VINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>';

  function balkHtml(bedrag) {
    var max = cfg.tier2 ? cfg.d2 : cfg.d1;
    var pct = Math.max(0, Math.min(100, (bedrag / max) * 100));
    var p1 = cfg.tier2 ? (cfg.d1 / cfg.d2) * 100 : 100;
    var g1 = bedrag >= cfg.d1, g2 = cfg.tier2 && bedrag >= cfg.d2;
    var html =
      '<div class="lf-cm__balk" role="img" aria-label="' + veilig(statusZin(bedrag)) + '">' +
        '<span class="lf-cm__spoor"><span class="lf-cm__vulling" style="width:' + pct.toFixed(1) + '%"></span></span>' +
        '<span class="lf-cm__bol' + (g1 ? ' is-aan' : '') + '" style="left:' + p1.toFixed(1) + '%" title="' + veilig(cfg.t.m1) + ' · ' + geld(cfg.d1) + '">' + (g1 ? ICO_VINK : ICO_SOK) + '</span>';
    if (cfg.tier2) {
      html += '<span class="lf-cm__bol lf-cm__bol--laatste' + (g2 ? ' is-aan' : '') + '" style="left:100%" title="' + veilig(cfg.t.m2) + ' · ' + geld(cfg.d2) + '">' + (g2 ? ICO_VINK : ICO_BOX) + '</span>';
    }
    return html + '</div>';
  }

  function productZin(m) {
    var prijs = m.prijs || 0;
    var totaal = meet + prijs;
    if (meet <= 0) {
      if (status(totaal) === 'A') { return vul(cfg.t.pla, 'bedrag', geld(cfg.d1 - totaal)); }
      return vul(cfg.t.plm, 'status', statusZin(totaal));
    }
    return vul(vul(cfg.t.pm, 'bedrag', geld(totaal)), 'status', statusZin(totaal));
  }

  function teken(m) {
    var el = m.el;
    var bedrag = meet;
    var zin;
    if (m.plek === 'product') {
      bedrag = meet + (m.prijs || 0);
      zin = productZin(m);
    } else {
      zin = statusZin(bedrag);
    }
    var s = status(bedrag);
    el.setAttribute('data-status', s);
    var html = '<p class="lf-cm__zin">' + veilig(zin) + '</p>' + balkHtml(bedrag);
    if (m.plek === 'sticky') {
      html += '<button type="button" class="lf-cm__sluit" data-lf-cm-sluit aria-label="' + veilig(cfg.t.sluit) + '">' +
        '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg></button>';
    }
    if (el.getAttribute('data-html') !== html) {
      el.innerHTML = html;
      el.setAttribute('data-html', html);
    }
    el.classList.add('is-gevuld');
  }

  /* ---------- het sticky balkje ---------- */
  var sticky = null;         // { wrap, m }
  var stickyTimer = null;
  function drawerOpen() {
    var d = document.getElementById('LfCartDrawer');
    return !!(d && d.classList.contains('is-open'));
  }
  function bovenKoopbalk() {
    var k = document.querySelector('.lf-koopbalk.is-zichtbaar');
    return !!k;
  }

  /* HET BALKJE GAAT NOOIT OVER DE KOOPKNOP HEEN.

     Gemeten op 10 september 2026, 375 x 812: de koopknop stond op 736-801 en
     dit balkje staat vast op 765-812. Een tik op het midden van de knop kwam
     dus op het balkje terecht, niet op de knop. document.elementsFromPoint gaf
     op die plek: Klaviyo-laag, lf-cm-sticky, en pas daarna de BUTTON.

     De bestaande regel is-boven-koopbalk hielp hier niet: die tilt het balkje
     alleen op als de meelopende koopbalk zichtbaar is, en die verschijnt juist
     pas als de echte knop uit beeld is. Precies in het geval dat misging stond
     hij dus laag.

     Nieuwe regel: staat de echte koopknop in beeld en komt hij tot in de
     onderste strook, dan wijkt het balkje. De koopknop wint altijd. */
  function koopknopDektAf() {
    var f = document.querySelector('form[action*="/cart/add"]');
    var k = f ? f.querySelector('[name="add"], .add-to-cart') : null;
    if (!k) { return false; }
    var r = k.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) { return false; }
    if (r.bottom <= 0 || r.top >= window.innerHeight) { return false; }
    var band = 56;
    if (sticky && sticky.wrap) {
      var w = sticky.wrap.getBoundingClientRect();
      if (w.height > 0) { band = w.height + 8; }
    }
    return r.bottom > (window.innerHeight - band);
  }

  function stickyBijwerken(vorigeStatus) {
    if (!sticky) { return; }
    var wrap = sticky.wrap;
    var s = status(meet);
    var dicht = lees('lfCmDicht', null);
    var cGetoond = lees('lfCmCGetoond', false);
    var nieuweMijlpaal = vorigeStatus != null && rang(s) > rang(vorigeStatus);

    /* Een nieuwe mijlpaal wint van het kruisje: dan mag hij eerder terugkomen. */
    if (dicht && nieuweMijlpaal && rang(s) > rang(dicht.status || 'A')) { dicht = null; schrijf('lfCmDicht', null); }
    if (dicht && Date.now() > dicht.tot) { dicht = null; schrijf('lfCmDicht', null); }
    if (nieuweMijlpaal && s === 'C') { cGetoond = false; schrijf('lfCmCGetoond', false); }

    var toon = meet > 0 && !dicht && !drawerOpen() && !koopknopDektAf() && !(s === 'C' && cGetoond);
    wrap.classList.toggle('is-boven-koopbalk', bovenKoopbalk());

    if (!toon) {
      if (!wrap.hidden) { wrap.classList.add('is-weg'); window.setTimeout(function () { wrap.hidden = true; wrap.classList.remove('is-weg'); }, 350); }
      return;
    }
    if (wrap.hidden) { wrap.hidden = false; wrap.classList.remove('is-weg'); }

    if (nieuweMijlpaal) {
      wrap.classList.remove('is-puls'); void wrap.offsetWidth; wrap.classList.add('is-puls');
      window.setTimeout(function () { wrap.classList.remove('is-puls'); }, 700);
    }

    /* Alles binnen: vier seconden laten zien, dan wegschuiven, en niet meer
       terugkomen zolang de status C blijft. */
    if (stickyTimer) { window.clearTimeout(stickyTimer); stickyTimer = null; }
    if (s === 'C') {
      stickyTimer = window.setTimeout(function () {
        schrijf('lfCmCGetoond', true);
        wrap.classList.add('is-weg');
        window.setTimeout(function () { wrap.hidden = true; wrap.classList.remove('is-weg'); }, 350);
      }, 4000);
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest ? e.target.closest('[data-lf-cm-sluit]') : null;
    if (!knop || !sticky) { return; }
    schrijf('lfCmDicht', { tot: Date.now() + 30 * 60 * 1000, status: status(meet) });
    sticky.wrap.classList.add('is-weg');
    window.setTimeout(function () { sticky.wrap.hidden = true; sticky.wrap.classList.remove('is-weg'); }, 350);
  });

  /* ---------- verversen ---------- */
  function tekenAlles(vorigeStatus) {
    mounts.forEach(teken);
    stickyBijwerken(vorigeStatus);
    schrijf('lfCmStatus', status(meet));
  }

  function verwerk(c) {
    cart = c;
    return meten(c).then(function (bedrag) {
      var vorige = lees('lfCmStatus', null);
      meet = bedrag;
      tekenAlles(vorige);
    });
  }

  function ververs() {
    if (bezig) { return bezig; }
    bezig = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(verwerk)
      .catch(function () { /* netwerk: laatste stand laten staan */ })
      .then(function () { bezig = null; });
    return bezig;
  }

  /* fetch één keer omwikkelen: elke wijziging van de wagen, door wie dan ook
     (thema, lade, staffelkiezer), levert daarna een verse meting op. */
  if (!window.__lfCmFetch && typeof window.fetch === 'function') {
    var oud = window.fetch;
    window.__lfCmFetch = true;
    window.fetch = function (u, o) {
      var p = oud.apply(this, arguments);
      try {
        var url = String((u && u.url) || u || '');
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function () { window.setTimeout(ververs, 60); }, function () {});
        }
      } catch (e) { /* stil */ }
      return p;
    };
  }
  document.addEventListener('cart:updated', function () { window.setTimeout(ververs, 30); });
  document.addEventListener('ajaxProduct:added', function () { window.setTimeout(ververs, 60); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { ververs(); } });

  /* Variantwissel op de productpagina: alleen opnieuw rekenen, niet ophalen. */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    mounts.forEach(function (m) {
      if (m.plek !== 'product') { return; }
      if (v && m.varianten && m.varianten[String(v.id)] != null) { m.prijs = m.varianten[String(v.id)]; }
      else if (v && typeof v.price === 'number') { m.prijs = v.price; }
      teken(m);
    });
  });

  /* Bij het scrollen opnieuw wegen: de koopknop schuift in en uit de onderste
     strook, en daar hangt nu aan of dit balkje mag staan. Eén meting per frame. */
  (function () {
    var bezig = false;
    window.addEventListener('scroll', function () {
      if (bezig || !sticky) { return; }
      bezig = true;
      window.requestAnimationFrame(function () { bezig = false; stickyBijwerken(null); });
    }, { passive: true });
    window.addEventListener('resize', function () { if (sticky) { stickyBijwerken(null); } }, { passive: true });
    window.addEventListener('orientationchange', function () { if (sticky) { stickyBijwerken(null); } });
  })();

  /* Lade open/dicht en koopbalk zichtbaar/onzichtbaar sturen het sticky balkje. */
  if ('MutationObserver' in window) {
    var kijk = function (el) {
      if (!el) { return; }
      new MutationObserver(function () { stickyBijwerken(null); }).observe(el, { attributes: true, attributeFilter: ['class'] });
    };
    document.addEventListener('DOMContentLoaded', function () {
      kijk(document.getElementById('LfCartDrawer'));
      kijk(document.querySelector('.lf-koopbalk'));
    });
    if (document.readyState !== 'loading') {
      kijk(document.getElementById('LfCartDrawer'));
      kijk(document.querySelector('.lf-koopbalk'));
    }
  }

  /* ---------- aanknooppunten ---------- */
  function koppel(el) {
    if (el.__lfCm) { return; }
    el.__lfCm = true;
    if (!cfg) { cfg = leesCfg(el); }
    var m = { el: el, plek: el.dataset.plek || 'lade', prijs: 0, varianten: null };
    if (m.plek === 'product') {
      try { m.varianten = JSON.parse(el.dataset.varianten || '{}'); } catch (e) { m.varianten = {}; }
      var id = el.dataset.variant;
      var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (form && form.value) { id = form.value; }
      m.prijs = (m.varianten && m.varianten[String(id)] != null) ? m.varianten[String(id)] : 0;
    }
    if (m.plek === 'sticky') {
      sticky = { wrap: el.closest('[data-lf-cm-sticky]') || el, m: m };
    }
    mounts.push(m);
  }

  function start() {
    var els = document.querySelectorAll('[data-lf-cadeaumeter]');
    for (var i = 0; i < els.length; i++) { koppel(els[i]); }
    if (!mounts.length) { return; }
    /* De eerste meting mag wachten tot de browser even niets te doen heeft. */
    if ('requestIdleCallback' in window) { window.requestIdleCallback(function () { ververs(); }, { timeout: 1500 }); }
    else { window.setTimeout(ververs, 200); }

    /* NA HET LADEN OPNIEUW WEGEN — nalevering 10 september 2026.

       De regel koopknopDektAf() werkte, maar hij werd één keer te vroeg
       toegepast. Gemeten op het live thema: bij een verse productpagina stond
       het balkje op 765 terwijl de koopknop op 737-802 lag, dus er nog steeds
       overheen. Eén resize-event later klopte het wel. Oorzaak: de eerste
       evaluatie loopt via requestIdleCallback, en op dat moment staat de knop
       nog niet op zijn eindpositie — de foto's eronder moeten nog binnenkomen.

       Een rect meten voordat de opmaak klaar is, is geen meting. Daarom hier
       nog drie keer nakijken, en bij window.load: dan staan de afbeeldingen
       er. Daarna houdt de scroll-terugval het bij. */
    var naMeten = function () { if (sticky) { stickyBijwerken(null); } };
    window.addEventListener('load', naMeten);
    [400, 1500, 3500].forEach(function (ms) { window.setTimeout(naMeten, ms); });
    if ('ResizeObserver' in window) {
      var vorm = document.querySelector('form[action*="/cart/add"]');
      if (vorm) { new ResizeObserver(naMeten).observe(vorm); }
    }
  }

  window.LfCadeaumeter = { ververs: ververs, koppel: koppel, status: function () { return { meet: meet, status: cfg ? status(meet) : null }; } };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
